import axios from "axios";

export default async function converter({ amount, to }) {
  const { data } = await axios.get("https://www.floatrates.com/daily/brl.json");

  return amount * data[to.toLowerCase()].rate;
}
